// class PredictiveSearch {
//   constructor(component) {
//     this.component = component;
//     this.searchInput = component.querySelector('[ref="searchInput"]');
//     this.resultsContainer = component.querySelector('[ref="predictiveSearchResults"]');
//     this.resetButton = component.querySelector('[ref="resetButton"]');
//     this.loadingText = component.dataset.loadingText || 'Loading...';
//     this.sectionId = component.dataset.sectionId || 'predictive-search-section';

//     if (this.searchInput) {
//       this.searchInput.addEventListener('input', (e) => this.onInput(e));
//       this.searchInput.addEventListener('focus', () => this.showResults());
//       this.resetButton.addEventListener('click', () => this.resetSearch());
//     }
//   }

//   showResults() {
//     this.resultsContainer.style.display = 'block';
//   }

//   hideResults() {
//     this.resultsContainer.style.display = 'none';
//   }

//   resetSearch() {
//     this.searchInput.value = '';
//     this.hideResults();
//   }

//   async onInput(e) {
//     const query = e.target.value.trim();

//     if (!query) {
//       this.resetSearch();
//       return;
//     }

//     this.resultsContainer.innerHTML = `<p class="predictive-search-loading">${this.loadingText}</p>`;
//     this.showResults();

//     try {
//       const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`;
//       const response = await fetch(url);
//       const data = await response.json();

//       // If products found
//       if (data.resources.results.products.length) {
//         this.renderProducts(data.resources.results.products, query);
//       } else {
//         this.resultsContainer.innerHTML = `
//           <div class="predictive-search-message">
//             No products found
//           </div>
//         `;
//       }
//     } catch (err) {
//       console.error('Predictive search error:', err);
//       this.resultsContainer.innerHTML = `<p class="predictive-search-no-results">Something went wrong</p>`;
//     }
//   }

//   renderProducts(products, query) {
//     // Use Shopify Liquid snippet endpoint via section render
//     // You can also render a simplified version here
//     const ul = document.createElement('ul');
//     ul.className = 'predictive-search-results__list predictive-search-results__wrapper-products list-unstyled';
//     ul.setAttribute('role', 'listbox');
//     ul.setAttribute('aria-label', `Search results for ${query}`);

//     products.forEach((product) => {
//       const li = document.createElement('li');
//       li.className = 'predictive-search-results__card predictive-search-results__card--product';
//       li.innerHTML = `
//         <a href="${product.url}" class="resource-card">
//           <img src="${product.image}" alt="${product.title}" width="500" />
//           <span class="resource-card__title">${product.title}</span>
//         </a>
//       `;
//       ul.appendChild(li);
//     });

//     this.resultsContainer.innerHTML = '';
//     this.resultsContainer.appendChild(ul);
//   }
// }

// // Initialize all predictive search components
// document.querySelectorAll('predictive-search-component').forEach((el) => new PredictiveSearch(el));
class PredictiveSearch {
  constructor(component) {
    this.component = component;
    this.searchInput = component.querySelector('[ref="searchInput"]');
    this.resultsContainer = component.querySelector('[ref="predictiveSearchResults"]');
    this.resetButton = component.querySelector('[ref="resetButton"]');
    this.loadingText = component.dataset.loadingText || 'Loading...';
    this.sectionId = component.dataset.sectionId || 'predictive-search-section';

    if (this.searchInput) {
      this.searchInput.addEventListener('input', (e) => this.onInput(e));
      this.searchInput.addEventListener('focus', () => {
        if (this.searchInput.value.trim().length > 0) this.showResults();
      });
      this.resetButton.addEventListener('click', () => this.resetSearch());
    }

    this.hideResults();
  }

  showResults() {
    this.resultsContainer.style.display = 'block';
  }

  hideResults() {
    this.resultsContainer.style.display = 'none';
  }

  resetSearch() {
    this.searchInput.value = '';
    this.hideResults();
  }

  async onInput(e) {
    const query = e.target.value.trim();

    if (!query) {
      this.resetSearch();
      return;
    }

    this.resultsContainer.innerHTML = `<p class="predictive-search-loading">${this.loadingText}</p>`;
    this.showResults();

    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`;
      const response = await fetch(url);
      const data = await response.json();

      if (data.resources.results.products?.length) {
        this.renderProducts(data.resources.results.products, query);
      } else {
        this.resultsContainer.innerHTML = `<div class="predictive-search-message">No products found</div>`;
      }
    } catch (err) {
      console.error('❌ Predictive search fetch failed:', err);
      this.resultsContainer.innerHTML = `<p class="predictive-search-no-results">Something went wrong</p>`;
    }
  }

  async renderProducts(products, query) {
    const ul = document.createElement('ul');
    ul.className = 'predictive-search-results__list predictive-search-results__wrapper-products list-unstyled';
    ul.setAttribute('role', 'listbox');
    ul.setAttribute('aria-label', `Search results for ${query}`);

    // Function to fetch the product JSON
    async function fetchProductJson(handle) {
      if (!handle) return null;
      try {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) throw new Error(`Product not found: ${handle}`);
        return await res.json();
      } catch (err) {
        console.warn(`⚠️ Failed to fetch product JSON for "${handle}":`, err.message);
        return null;
      }
    }

    const productPromises = products.map(async (p) => {
      let imageUrl = p.image || '';
      let handle = p.handle || (p.url ? p.url.split('/').pop().replace(/\/$/, '') : '');

      if (!handle) {
        console.warn('⚠️ Skipping product without valid handle:', p);
        return null;
      }

      const fullProduct = await fetchProductJson(handle);

      if (fullProduct?.media?.length) {
        // Check for image alt text that includes "flag" (case-insensitive)
        const flagMedia = fullProduct.media.find(
          (m) =>
            m.alt &&
            typeof m.alt === 'string' &&
            m.alt.toLowerCase().includes('flag')
        );

        if (flagMedia) {
          imageUrl = flagMedia.src;
        } else if (fullProduct.featured_image) {
          imageUrl = fullProduct.featured_image;
        } else if (fullProduct.images?.length) {
          imageUrl = fullProduct.images[0];
        }
      } else if (fullProduct?.images?.length) {
        // Fallback for older theme structures
        const flagImg = fullProduct.images.find(
          (img) =>
            img.alt &&
            typeof img.alt === 'string' &&
            img.alt.toLowerCase().includes('flag')
        );
        if (flagImg) imageUrl = flagImg.src || flagImg;
        else imageUrl = fullProduct.images[0];
      }

      return {
        url: p.url,
        title: p.title,
        imageUrl
      };
    });

    const results = (await Promise.all(productPromises)).filter(Boolean);

    if (!results.length) {
      this.resultsContainer.innerHTML = `<div class="predictive-search-message">No matching products found</div>`;
      return;
    }

    results.forEach((prod) => {
      const li = document.createElement('li');
      li.className = 'predictive-search-results__card predictive-search-results__card--product';
      li.innerHTML = `
        <a href="${prod.url}" class="resource-card">
          <div class="predictive-search__image-wrapper">
            <img src="${prod.imageUrl}" alt="${prod.title}" loading="lazy" />
          </div>
          <span class="resource-card__title">${prod.title}</span>
        </a>
      `;
      ul.appendChild(li);
    });

    this.resultsContainer.innerHTML = '';
    this.resultsContainer.appendChild(ul);
  }
}

document.querySelectorAll('predictive-search-component').forEach((el) => new PredictiveSearch(el));
